import React, { useEffect, useState } from "react";
import s from "./Countdown.module.scss";

const Countdown = ({ initialMinutes = 2, initialSeconds = 59 }) => {
  const [time, setTime] = useState(initialMinutes * 60 + initialSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTimeUnit = (unit) => String(unit).padStart(2, "0");

  const minutes = formatTimeUnit(Math.floor(time / 60));
  const seconds = formatTimeUnit(time % 60);
  const hours = formatTimeUnit(Math.floor(time / 3600));

  return (
    <div className={s.container}>
      <span className={s.expiresLabel}>{window.checkout_popup?.amount_upsell_expiresLabel}</span>
      <div className={s.countdown}>
        {[hours, minutes, seconds].map((unit, idx) => (
          <React.Fragment key={idx}>
            <div className={s.count}>{unit}</div>
            {idx < 2 && <span className={s.separator}>:</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
